.gi{z-index:2;}